import React, { useEffect, useState } from "react";
import { Row, Col, Form, Table, Dropdown } from "react-bootstrap";
import caretdown from "../../../assets/images/caretdown.svg";
import "./style.css";
import { productListData } from "../../../data/summaryReportData";
import { getProductList } from "../../../services/auth.api";

interface CertifiedProductRecord {
  Level_1__c: string | null;
  Level_2__c: string | null;
  Related_Species__c: string | null;
  Primary_Activity__c: string | null;
  Secondary_Activity__c: string | null;
  Claim__c: string[] | null;
}

interface OpportunityCertificate {
  Certified_Products__r: {
    records: CertifiedProductRecord[] | null;
  } | null;
}

interface FscProductGroupListProps {
  formData: any;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  productData: any;
  rowData: any;
}

const FscProductGroupList: React.FC<FscProductGroupListProps> = ({
  formData,
  setFormData,
  productData,
  rowData,
}) => {

  const [opportunityProducts, setOpportunityProducts] = useState<any>([]);
  
    const fetchData = async () => {
      let productRecords: any = [];
      if (rowData) {
        await getProductList(rowData.opportunityId).then((response => {
          if (response.opportunityCertificates) {
            response.opportunityCertificates.forEach((opportunity: any) => {
              if (opportunity.Certified_Products__r && opportunity.Certified_Products__r.records) {
                productRecords = [...productRecords, ...opportunity.Certified_Products__r.records];
              }
            })
          }
        }))
      }
      setOpportunityProducts(productRecords);
    };
  
    useEffect(() => {
      fetchData()
    }, [rowData, setOpportunityProducts])
  
    
    const tableHeaders = [
      {
        label: "Certificate ID",
      },
      {
        label: "Product Code L1", subLabel: "(per FSC-STD-40-004a)",
      },
      { label: "Product Code L2", subLabel: "(per FSC-STD-40-004a)" },
      { label: "Product Code L3", subLabel: "(per FSC-STD-40-004a)" },
      { label: "Trade Name", subLabel: "(Common name)" },
      { label: "Species of Material Outputs", subLabel: "(Latin name)" },
      {
        label: "Primary Activity",
        subLabel: "(choose number(s) from table below)",
      },
      {
        label: "Secondary Activity",
        subLabel: "(choose number(s) from table below)",
      },
      { label: "FSC Output Claim", subLabel: "(FSC 100%, FSC Mix X%, etc.)" },
    ];

  const fscGroupList = [
    { label: "Organization’s Product Groups are accurately reflected in the FSC database, no changes.", value: "Matched" },
    { label: "Changes required, see “SECTION 2: CONFIRMATION OF CHANGES” (above) with list of changes.", value: "Is attached as Annex" },
    { label: "Not Applicable, evaluation audit.", value: "Not Applicable, evaluation audit" },
  ];



  return (
    <>
      <div className="fsc-product-group-header">
        <Form.Label className="me-2" style={{ }}>
          FSC Product Group List
        </Form.Label>
        <Form.Check
          type="checkbox"
          id="na-checkbox"
          label="N/A"
          className="na-checkbox"
          defaultChecked={formData.FscProductGroupList.FSC_Product_Group_List__c}
          disabled
        />
      </div>
     
      <div style={{marginLeft: "20px"}}>
        <p style={{fontWeight: "500", fontSize: "16px" }}>1.Check here to confirm that the client’s listing on the FSC database has been compared to the organization’s current product group list.</p>
        <div className="fsc-product-reocrd">
        <Row>
          <Col>
            <div>
              {fscGroupList.map((option) => (
                <Form.Check
                  key={option.value}
                >
                  <Form.Check
                    type="checkbox"
                    name={option.value}
                    key={option.value}
                    defaultChecked={formData.FscProductGroupList.Product_List_Comparison_SCS_FSC__c === option.value}
                    // onChange={handleRadioChange}
                    className="fsc-category-check-input"
                    disabled
                  />
                  <Form.Check.Label className="fsc-categories-label">
                    {option.label}
                  </Form.Check.Label>
                </Form.Check>
              ))}
            </div>
          </Col>
        </Row>
        </div>
        <hr/>
        <p><b>2. The PGL must be included within this summary report. If PGL exceeds 15 entries, submit an additional pdf with remaining PGLs. Note:</b> The client’s full written procedures cannot be attached, the PGL must be included separate from the organization’s written procedures as a record or excel spreadsheet. All required information from the table below must be included in the attachment.</p>
      </div>

      <div className="p-4">
       
            <Table bordered className="fsc-product-table">
               <thead>
                <tr>
                  {tableHeaders.map((header, index) => (
                    <th key={index} className="fsc-product-table-header">
                      <p className="fsc-product-table-header-label">{header.label}</p>
                      <span className="fsc-product-table-header-sublabel">
                        {header.subLabel}
                      </span>
                    </th>
                  ))}
                </tr>
              </thead>
              {opportunityProducts.length ? (
                <tbody className="fsc-product-table-body">
                {opportunityProducts.map((product: any) => (
                  <tr key={product.id}>
                    <td>{product.Certificate_Number__c || "--"}</td>
                    <td>{product.Level_1__c || "--"}</td>
                    <td>{product.Level_2__c || "--"}</td>
                    <td>{product.Level_3__c || "--"}</td>
                    <td>{product.Trade_Name__c || "--"}</td>
                    <td>{product.Related_Species__c || "--"}</td>
                    <td>{product.Primary_Activity__c || "--"}</td>
                    <td>{product.Secondary_Activity__c || "--"}</td>
                    <td>{product.Claim__c || "--"}</td>
                  </tr>
                ))}
                </tbody>
              ) : (
                <></>
              )}
            </Table>
      
          <Form.Check
            type="checkbox"
            id="na-checkbox"
            label="Organization's Product Group List is provided as a separate record."
            defaultChecked={formData.FscProductGroupList.PGL_FSC_as_seperate_record__c}
            className="mt-2"
            disabled
          />
          <p className="mt-2"><i>*Please include the most up-to-date PGL. If product list exceeds 15, please submit additional document as attachment</i></p>
      </div>
    </>
  );
};

export default FscProductGroupList;
